import styled from 'styled-components';

export const Body = styled.div`
  overflow-x: hidden;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 80px;
  background: #F5F5F5;
  min-height: 100vh;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const DateSection = styled.div`
  margin-bottom: 20px;
`;

export const DateHeader = styled.div`
  padding: 16px 20px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: transparent;
  text-align: left;
`;

export const ReservationItem = styled.div`
  margin: 0 20px 12px 20px;
  display: flex;
  gap: 16px;
  align-items: flex-start;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ReservationCard = styled.div`
  background: white;
  padding: 20px;
  border-radius: 12px;
  flex: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const TimeSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 60px;
`;

export const TimePeriod = styled.div`
  font-size: 10px;
  color: #666;
  margin-bottom: 1px;
  line-height: 1;
`;

export const Time = styled.div`
  font-size: 13px;
  color: #333;
  font-weight: 500;
  line-height: 1.2;
`;

export const CardContent = styled.div`
  display: flex;
  gap: 16px;
  flex: 1;
`;

export const Divider = styled.div`
  width: 3px;
  background: #1FBC70;
  border-radius: 2px;
  align-self: stretch;
`;

export const InfoSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
`;

export const FacilityName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  text-align: left;
`;

export const FacilityDetail = styled.div`
  font-size: 13px;
  color: #666;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DetailIcon = styled.span`
  font-size: 14px;
  color: #999;
`;

export const EmptyMessage = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #999;
  font-size: 14px;
`;
